const moduleSettings = {
  narvi: [
    {
      nombre: 'facturaElectronica',
      descripcion: 'Factura Electrónica',
      tooltip: '',
      icono: 'description',
      habilitado: true,
      visible: true
    }
  ],
  febos: [
    {
      nombre: 'materialRequests',
      descripcion: 'Solicitud de materiales',
      tooltip: '',
      icono: 'description', // TODO: cambiar icono por alguno con relacion - material icons
      habilitado: true,
      visible: true,
      permission: 'WBF03' // TODO: set permission
    },
    {
      nombre: 'billing',
      descripcion: 'Facturación',
      tooltip: '',
      icono: 'assignment', // TODO: cambiar icono por alguno con relacion - material icons
      habilitado: true,
      visible: true,
      permission: 'WBF02' // TODO: set permission
    },
    {
      nombre: 'edSettings',
      descripcion: 'Configuraciones',
      tooltip: '',
      icono: 'settings',
      habilitado: true,
      visible: true,
      permission: 'WBF01'
    }
  ],
  aprobacionesApp: [
    {
      nombre: 'approvalsMobileApp',
      descripcion: 'Aprobaciones',
      tooltip: '',
      icono: 'done_all',
      habilitado: true,
      visible: true,
      permission: 'ED052'
    },
  ],
  aduanas: [
    {
      nombre: 'aduanas',
      descripcion: 'Subastas',
      tooltip: '',
      icono: 'store',
      habilitado: true,
      visible: true,
      permission: 'ED153'
    },
    {
      nombre: 'aduanasSettings',
      descripcion: 'Configuraciones',
      tooltip: '',
      icono: 'settings',
      habilitado: true,
      visible: true,
      permission: 'ED154'
    }
  ],
  ed: [
    {
      nombre: 'expedientesEd',
      descripcion: 'Expedientes',
      tooltip: '',
      icono: 'description',
      habilitado: true,
      visible: true,
      permission: 'ED003',
      route: { name: 'expedientes-dashboard', params: { view: 'files' } }
    },
    {
      nombre: 'officesManagement',
      descripcion: 'Oficinas de Partes',
      tooltip: '',
      icono: 'gavel',
      habilitado: true,
      visible: true,
      permission: 'ED112',
      route: { name: 'expedientes-dashboard', params: { view: 'files' } }
    },
    {
      nombre: 'internOfficesManagement',
      descripcion: 'Oficinas Internas',
      tooltip: '',
      icono: 'approval',
      habilitado: true,
      visible: true,
      permission: 'ED120',
      route: { name: 'expedientes-dashboard', params: { view: 'files' } }
    },
    {
      nombre: 'approvals',
      descripcion: 'Aprobaciones',
      tooltip: '',
      icono: 'done_all',
      habilitado: true,
      visible: true,
      permission: 'ED052',
      route: 'approval-dashboard'
    },
    {
      nombre: 'gestionDocumentos',
      descripcion: 'Gest. Documentos',
      tooltip: '',
      icono: 'folder',
      habilitado: true,
      visible: true,
      permission: 'ED060',
      route: 'document-management'
    },
    {
      nombre: 'edSettings',
      descripcion: 'Configuraciones',
      tooltip: '',
      icono: 'settings',
      habilitado: true,
      visible: true,
      permission: 'ED119'
    },
    {
      nombre: 'supportEd',
      descripcion: 'Soporte',
      tooltip: '',
      icono: 'touch_app',
      habilitado: true,
      visible: true,
      permission: 'FEB99'
    }
  ]
};

export default {
  data() {
    return {
      modules: moduleSettings[process.env.VUE_APP_PRODUCTO]
    };
  }
};
